import { Fragment, useEffect, useState } from 'react';
import cross from '~/assets/icons/cross.svg';
import { playSound, Sound } from '~/assets/sounds';
import { IPlayerSearchResult, rage } from '~/rage';
import { AppMessageFriendsRequests } from '../AppMessageFriendsRequests';
import { AppMessagePlayerCard, getBottomState } from '../AppMessagePlayerCard';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledEmptyContainer,
	StyledHeadContainer,
	StyledNotFoundContainer,
	StyledResetContainer,
	StyledSearchInput,
	StyledSearchResultContainer,
	StyledSearchResultInfo,
	StyledSearchResultList,
} from './AppMessageSearchTab.styled';

const AppMessageSearchTab = () => {
	const [searchInputValue, setSearchInputValue] = useState('');
	const [players, setPlayers] = useState<IPlayerSearchResult[]>([]);

	useEffect(() => {
		if (searchInputValue.length < 3) {
			return;
		}

		rage.search
			.findOnlinePlayerByNickname(searchInputValue ?? '')
			.then((filteredPlayers) => {
				setPlayers(filteredPlayers);
			})
			.catch((err) => rage.notifications.showException(err));
	}, [searchInputValue]);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<TextLabel style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Поиск
				</TextLabel>
				<StyledSearchInput
					placeholder={'Введите имя игрока для поиска'}
					value={searchInputValue}
					onChange={(e) => setSearchInputValue(e.target.value)}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				<AppMessageFriendsRequests />
			</StyledHeadContainer>
			<StyledSearchResultContainer>
				{searchInputValue.length < 3 ? (
					<StyledEmptyContainer>
						<TextLabel>Используйте поиск чтобы найти игрока</TextLabel>
					</StyledEmptyContainer>
				) : (
					<Fragment>
						<StyledSearchResultInfo>
							<TextLabel
								style={{ fontSize: 14, fontWeight: 400, color: '#ffffff' }}
							>
								<span style={{ opacity: 0.25 }}>Результаты поиска “</span>
								<span style={{ fontWeight: 700, opacity: 0.5 }}>
									{searchInputValue}
								</span>
								<span style={{ opacity: 0.25 }}>” </span>
								<span style={{ opacity: 0.1 }}>
									(Найдено {players.length} игроков)
								</span>
							</TextLabel>
							<StyledResetContainer
								onClick={() => {
									setSearchInputValue('');
									playSound(Sound.ClickButton);
								}}
								onMouseEnter={() => playSound(Sound.LinkCursor)}
							>
								<img src={cross} />
								<TextLabel>Сбросить поиск</TextLabel>
							</StyledResetContainer>
						</StyledSearchResultInfo>
						{!players.length && (
							<StyledNotFoundContainer>
								<TextLabel>
									К сожалению, но игрока с ником “{searchInputValue}”<br />
									не удалось найти
								</TextLabel>
							</StyledNotFoundContainer>
						)}
						<StyledSearchResultList>
							{players.map((player, index) => (
								<AppMessagePlayerCard
									key={player.nickname}
									nickname={player.nickname}
									index={index}
									bottom={getBottomState(
										Math.ceil((index + 1) / 3),
										Math.ceil(players.length / 3),
									)}
								/>
							))}
							{/* <AppMessagePlayerCard /> */}
							{/* <AppMessagePlayerCard online /> */}
							{/* <AppMessagePlayerCard favorite /> */}
							{/* {new Array(50).fill(0).map((_, i) => ( */}
							{/* 	<AppMessagePlayerCard online favorite key={i} /> */}
							{/* ))} */}
						</StyledSearchResultList>
					</Fragment>
				)}
			</StyledSearchResultContainer>
		</StyledContainer>
	);
};

export { AppMessageSearchTab };
